import Phaser from 'phaser';

export class ErrorScene extends Phaser.Scene {
  private graphics: any;

  constructor() {
    super('ErrorScene');
  }

  create() {
    console.log('*****ErrorScene*****');
    this.graphics = this.add.graphics();
    const messages = [] as any[];

    if (!!window._po_gm.config && !!window._po_gm.config.errorMsg) {
      window._po_gm.config.errorMsg.forEach((msg, index) =>
        messages.push({
          text: msg,
          color: '#525352',
          fontSize: '18',
          yPos: this.physics.world.bounds.height * 0.35 + 30 * index
        })
      );
    } else {
      messages.push({
        text: 'An error occurred. Please try again later',
        color: '#525352',
        fontSize: '18',
        yPos: this.physics.world.bounds.height * 0.35
      });
    }

    this.graphics.fillStyle(0xffffff, 1);
    this.graphics.fillRoundedRect(this.physics.world.bounds.width * 0.01, this.physics.world.bounds.width * 0.4, this.physics.world.bounds.width * 0.98, this.physics.world.bounds.width * 0.4, 15);

    messages.forEach((message: any) => {
      this.add.text(this.physics.world.bounds.width * 0.5, message.yPos, message.text, {
        color: message.color,
        font: message.fontSize + 'px odudo-semiBold'
      }).setOrigin(0.5);
    });
  }
}
